export default __webpack_public_path__ + "static/media/green.fa825146.svg";